import React from 'react';
import { useDataRetention } from "../../Components/DataRetention/DataRetention";
import { getBrandName } from "../../Components/getBrandName";
const DataRetention = () => {
  const { sections, generateContent } = useDataRetention();
  const { brandName} = getBrandName();

  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-heading text-center">
        <h2>Data Retention & Deletion Policy</h2>
        <p className="text-muted" style={{fontSize:"0.8rem"}}>Effective Date: <strong>July 3, 2025</strong></p>
      </div>

      <div className="privacy-container">
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
        <p>
          At {brandName}, we value your trust. We are committed to protecting your personal and business-related information by retaining it only for as long as necessary and deleting it securely when it’s no longer needed. This policy outlines how we manage data retention, deletion requests, and compliance with applicable laws.
          </p>
              {sections.map((section) => (
                <div key={section.id} className="mb-5">
                  <h5 className="fw-bold">{section.title}</h5>
                  <div className="text-muted">
                    {generateContent(section.id)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataRetention;
